<template>
  <div class="tab">
    <div
      class="tab-title"
      :class="{ checked: status === 'ongoing' }"
      @click="$emit('changeTab', 'ongoing')"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.586 13.414L7.75702 10.586L6.34302 12L10.586 16.243L17.656 9.17202L16.243 7.75702L10.586 13.414Z"
          fill="currentColor"
        />
      </svg>
      <span>진행 중</span>
    </div>
    <div
      class="tab-title"
      :class="{ checked: status === 'all' }"
      @click="$emit('changeTab', 'all')"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 5.5H19"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M5 11.5H19"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M5 17.5H19"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
      <span>전체 주문 </span>
    </div>
  </div>
</template>
<style scoped>
.tab {
  display: flex;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: var(--gray-400);
}

.tab-title {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 12px 16px 12px 12px;
  gap: 4px;
  border-bottom: 2px solid transparent;
}

.tab-title:hover {
  color: var(--gray-500);
}
.tab-title.checked {
  color: var(--primary-500);
  border-color: var(--primary-500);
}
</style>
<script>
export default {
  props: ["tabStatus"],
  computed: {
    status() {
      return this.tabStatus;
    }
  }
};
</script>
